import { Directive, Input, Renderer2, SimpleChanges } from "@angular/core";
import { NumericTextBoxComponent } from "@progress/kendo-angular-inputs";

@Directive({
  selector: 'kendo-numerictextbox'
})
export class StopWheelDirective {
  @Input() stopWheel: boolean = false;
  private stopInputWheelFn;
  private stopSpinnersWheelFn;

  constructor(private host: NumericTextBoxComponent, private renderer: Renderer2) { }

  ngAfterViewInit() {
    if (this.stopWheel) {
      this.stopWheelEvent();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.stopWheel && !changes.stopWheel.firstChange) {
      if (changes.stopWheel.currentValue) {
        this.stopWheelEvent();
      } else {
        this.stopListeners();
      }
    }
  }

  ngOnDestroy() {
    this.stopListeners();
  }

  private stopWheelEvent() {
    const inputElement: HTMLElement = this.host.numericInput.nativeElement;
    const spinnersWrapperElement: HTMLElement = inputElement.nextElementSibling as HTMLElement;
    if (inputElement) {
      this.stopInputWheelFn = this.renderer.listen(inputElement, 'wheel', (event) => {
        event.stopImmediatePropagation();
      });
    }
    if (spinnersWrapperElement) {
      this.stopSpinnersWheelFn = this.renderer.listen(spinnersWrapperElement, 'wheel', (event) => {
        event.stopImmediatePropagation();
      });
    }
  }

  private stopListeners() {
    if (this.stopInputWheelFn) {
      this.stopInputWheelFn();
    }

    if (this.stopSpinnersWheelFn) {
      this.stopSpinnersWheelFn();
    }
  }
}
